// extracted by mini-css-extract-plugin
module.exports = {"container":"Todo_container__Q4Hnj","task":"Todo_task__1kBEE","done":"Todo_done__2D7M9"};